import { CONTACT_INFO_FIELDS } from '../constants';

const { KNOCK_EMAIL, OWNER } = CONTACT_INFO_FIELDS;

export const FIELD_LABELS = {
  [OWNER]: 'Owner',
  [KNOCK_EMAIL]: 'Knock Email',
};

export const CONTACT_TEXT_FIELDS = [OWNER, KNOCK_EMAIL];
